import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { pushGTMEvent } from 'pubweb-smokey/dist/utils/analytics';
import { getWebpageTemplateContent } from '@services/contentfulService';
import { WebpageTemplate } from '@components/Shared/WebpageTemplate/WebpageTemplate';

const LandingPage = ({ pageInfo }) => {
  useEffect(() => {
    pushGTMEvent('gtm-crsmd-crossmod-video');
  }, []);

  return <WebpageTemplate pageInfo={pageInfo} />;
};

export default LandingPage;

const webPageKey = '46e0LQr5q15J4MZbYaQ8MT';

export async function getServerSideProps() {
  let webPageContent = null;

  await Promise.all([
    getWebpageTemplateContent(webPageKey)
      .then((response) => {
        webPageContent = response;
      })
      .catch(() => {
        console.error('no content');
      }),
  ]);

  return {
    props: {
      pageInfo: webPageContent,
    },
  };
}

LandingPage.propTypes = {
  pageInfo: PropTypes.object,
};
